import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MuckpileAnalyticsMapService } from '@app/new-ui/muckpile-list/muckpile-analytics-map.service';
import { Device, muckpileQuery } from '@models';
import { Subscription } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';

@Component({
	selector: 'app-muckpile-data-report',
	templateUrl: './muckpile-data-report.component.html',
	styleUrls: ['./muckpile-data-report.component.scss']
})
export class MuckpileDataReportComponent implements AfterViewInit, OnDestroy {
	@ViewChild('map', { static: false }) mapElement: ElementRef;

	constructor(
		private fragQuery: FragQueryService,
		private readonly route: ActivatedRoute,
		private muckpileAnalyticsMapService: MuckpileAnalyticsMapService,
	) { }

	public muckpileData$ = this.fragQuery.muckpileData$;
	public muckpiles$ = this.fragQuery.muckpiles$
	public isActualOffSpec = false;
	public isImportedOffSpec = false;
	public device$ = this.fragQuery.device$;
	public graph$ = this.fragQuery.graph$
	public particleSizeUnit$ = this.fragQuery.particleSizeUnit$;
	public areaUnit$ = this.fragQuery.AreaAbbr$;
	private subscriptions: Subscription = new Subscription();
	private mapInitialized = false;

	public ngOnInit(): void {
		this.subscriptions.add(this.muckpiles$.subscribe((muckpiles) => {
			const fragment = JSON.parse(this.route.snapshot.fragment);
			const selectedMuckpile = muckpiles.find(muckpile => muckpile.id === fragment.muckpileId);
			this.fragQuery.muckpile$.next(selectedMuckpile)
		}))
	}

	ngAfterViewInit() {
		if (!this.mapInitialized) {
			setTimeout(() => {
				this.muckpileAnalyticsMapService.initializeMap([0, 0], this.mapElement);
				this.mapInitialized = true;
			}, 100);
		}
	}

	ngOnDestroy() {
		this.muckpileAnalyticsMapService.cleanup();
		this.mapInitialized = false;
        this.subscriptions.unsubscribe();
	}

	public setImportedOffSpec(isOffSpec: boolean) {
		this.isImportedOffSpec = isOffSpec
	}

	public setActualOffSpec(isOffSpec: boolean) {
		this.isActualOffSpec = isOffSpec
	}

	public isCustomSizeEnabled(device: Device | null): boolean {
		if (!device) return false;
		return device.preferCustomSizes && device.targetSizes !== '[]' && device.targetSizes.length > 0;
	}

	public isEmptyObject = (obj: muckpileQuery.details.Fragment): boolean => {
		return obj === null || obj === undefined ||
			(Array.isArray(obj.psd) && obj.psd.length === 0) &&
			(Array.isArray(obj.dxx) && obj.dxx.length === 0);
	};
}
